export default "__VITE_ASSET__CLiit$Ch__"